import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Content from '../../../layout/Content';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { DEPOSIT_MIGRATION_PATH } from '../../../../config/paths';
import { postDepositMigration } from '../../../../actions';
import DepositMigrationForm from './DepositMigrationForm';

const NewDepositMigration = ({ breadcrumbs, dispatchPostDepositMigration }) => {
  const onSubmit = ({ bank, file }) =>
    dispatchPostDepositMigration({ bankId: bank.value, file });

  const subtitle = (
    <span>
      El archivo se lee, se limpia y se cruza en una sola pasada según el banco:
      en BCP primero contra los depósitos de liquidaciones y luego contra los
      pagos de comprobantes manuales; en Pichincha solo contra los pagos de
      comprobantes manuales. No hay estado intermedio: cuando la pantalla
      responde, la carga ya está cerrada con sus resultados. Puede tardar.
    </span>
  );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Cargar estado de cuenta"
      subtitle={subtitle}
      content={<DepositMigrationForm onSubmit={onSubmit} />}
    />
  );
};

NewDepositMigration.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostDepositMigration: PropTypes.func.isRequired,
};

const mapStateToProps = ({ SalesUnit }) => ({
  breadcrumbs: [
    ...SalesUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Cargas del estado de cuenta',
      href: DEPOSIT_MIGRATION_PATH,
    },
    {
      text: 'Nueva',
      href: '',
    },
  ],
});

const mapDispatchToProps = {
  dispatchPostDepositMigration: postDepositMigration,
};

export { NewDepositMigration };
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewDepositMigration);
